'use strict';

module.exports = require('./websocket');